import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useSEO } from "../lib/seo";
import { ArrowRight } from "lucide-react";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/courses?limit=200").then((r) => {
      const m = {};
      r.data.forEach((c) => { m[c.category] = (m[c.category] || 0) + 1; });
      setCounts(m);
    }).catch(() => {});
  }, []);

  useSEO({
    title: "All certification categories",
    description: "Browse all certification practice test categories on BeforeExam — AWS, Azure, GCP, Kubernetes, DevOps, Security, Cisco, PMP, AI/ML and more.",
  });

  return (
    <div data-testid="categories-page">
      <section className="border-b border-border bg-[color:var(--brand-cream-2)]">
        <div className="container-x py-12">
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">All <span className="font-serif text-gradient-gold">categories</span></h1>
          <p className="mt-2 text-muted-foreground max-w-2xl">{cats.length} certification tracks · Updated for 2026 · Detailed explanations on every question</p>
        </div>
      </section>
      <section className="container-x py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cats.map((c) => (
            <Link
              key={c.id}
              to={`/marketplace?category=${encodeURIComponent(c.name)}`}
              className="group rounded-xl border border-border bg-card p-6 card-hover flex items-center gap-4"
              data-testid={`category-page-card-${c.slug}`}
            >
              <div className="h-12 w-12 rounded-md flex items-center justify-center font-display text-xl text-white" style={{ background: c.color }}>
                {c.name.charAt(0)}
              </div>
              <div className="flex-1">
                <div className="font-display text-lg">{c.name}</div>
                <div className="text-xs text-muted-foreground mt-0.5">{counts[c.name] || 0} practice tests</div>
              </div>
              <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-[color:var(--brand-amber)] transition" />
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
